import { Layout, Grid, Space } from '@arco-design/web-react'
import { FooterProps } from '@arco-design/web-react/es/Layout/interface'
import cs from 'classnames'
import logoLight from '@/assets/logo_light.png'
import Subscribe from '@/assets/gzh.jpeg'
import Mailbox from '@/assets/Mailbox.png'
import FaceBook from '@/assets/FaceBook.png'
import Twitter from '@/assets/Twitter.png'
import iconWhatsApp from '@/assets/ic_whatsapp.png'
import useLocale from '@/utils/useLocale'
import useLang from '@/utils/useLang'
import styles from './style/index.module.less'
import Image from 'next/image'
import { Language } from '@/utils/language'
import useToken from '@/hooks/useToken'
import useGetVersionData from '@/hooks/useGetVersionData'
import UpdateLogComp from '@/pages/platform/update-log'
import Link from 'next/link'
import useLocalePath from '@/hooks/useLocalePath'
import { FaDiscord, FaLinkedin } from 'react-icons/fa'
import { CACHE_TIMESTAMP, getCustomerServiceQrcodeUrl } from '@/utils/constants'

const Row = Grid.Row

export const useFooterLinks = () => {
  const t = useLocale()
  return [
    {
      name: t['seo.sitemap.product_breadcrumb'],
      href: '/sitemap/products/best-selling-all-products-in-united-states-on-tiktok/1'
    },
    {
      name: t['seo.sitemap.influencer_breadcrumb'],
      href: '/sitemap/influencers/hot-all-influencers-in-united-states-on-tiktok/1'
    },
    {
      name: t['seo.sitemap.shop_breadcrumb'],
      href: '/sitemap/shops/best-selling-all-products-in-united-states-on-tiktok/1'
    },
    {
      name: t['footer.link.perfcloud'],
      href: 'https://www.perfcloud.cn/'
    }
  ]
}

function Footer(props: FooterProps = {}) {
  const t = useLocale()
  const { isLogin } = useToken()

  const { className, ...restProps } = props
  const lang = useLang()
  const { updateLogs, visible, setVisible } = useGetVersionData()
  const isNotChinese = lang !== 'zh-CN'

  const { getLocalePath } = useLocalePath()

  const links = useFooterLinks()

  const products = [
    {
      name: 'EchoTik',
      desc: t['echotik_desc'],
      href: 'https://echotik.live',
      icon: <Image src={logoLight?.src} alt="logo" width={130} height={26} />
    },
    // {
    //   name: '达管家',
    //   desc: 'TikTok达人主动开发平台',
    //   href: 'https://daguanjia.xyz?ref=echotik',
    //   icon: <IconDa />,
    //   hide: lang !== 'zh-CN'
    // },
    {
      name: 'CreatOk',
      desc: t['creatok_desc'],
      href: 'https://creatok.ai',
      icon: <Image src={'https://static.echotik.live/assets/creatok.webp'} alt="logo" width={130} height={30} />
    },
    {
      name: '跨境通告',
      desc: 'TikTok专属信息撮合平台',
      href: 'https://www.kjnote.cn/',
      icon: <Image src={'https://static.echotik.live/web/kuajing_logo.jpeg'} alt="logo" width={130} height={30} />,
      hide: lang !== 'zh-CN'
    }
    // {
    //   name: '领麦分销',
    //   desc: '全球一件代发货盘平台',
    //   href: 'http://www.matelead.com',
    //   icon: <Image src={'https://static.echotik.live/assets/metalead_logo.jpg'} alt="logo" width={130} height={30} />,
    //   hide: lang !== 'zh-CN'
    // }
  ]

  return (
    <Layout.Footer className={cs(styles.footer, className)} {...restProps}>
      <div className={styles.container}>
        <Row>
          <Image src={logoLight?.src} alt="logo" width={170} height={31} />
          {isLogin && updateLogs?.version && (
            <div
              className={styles.version}
              onClick={() => {
                updateLogs?.changelog && window.open(updateLogs?.changelog)
              }}
            >
              v{updateLogs?.version}
            </div>
          )}
        </Row>

        <div className={styles['footer-content']}>
          <div className={styles.aboutUs}>
            <div className={styles['footer-content-headline']}>{t['footer.aboutUs']}</div>
            <div className={styles.aboutUsText}>{t['footer.aboutUs.desc']}</div>
            <div style={{ marginTop: 10 }}>
              <div className={styles['footer-content-headline-wrap']}>
                <div className={styles['footer-content-headline']}>{t['product_list']}</div>
                <div className={styles['footer-content-more']}>
                  <a href={`/${lang === 'zh-CN' ? 'zh' : 'en'}/products`} target="_blank" rel="noreferrer">
                    {t['message.seeMore']}
                  </a>
                </div>
              </div>

              {products
                .filter((item) => !item.hide)
                .map((product, index) => {
                  return (
                    <a href={product.href} target="__blank" key={index}>
                      <div className={styles['footer-product-item']}>
                        <Space className={styles['footer-product-content']}>
                          <div className={styles['footer-product-icon']}>{product.icon}</div>
                          <div className={styles['footer-product-text']}>
                            <div className={styles['footer-product-name']}>{product.name}</div>
                            <div className={styles['footer-product-desc']}>{product.desc}</div>
                          </div>
                        </Space>
                      </div>
                    </a>
                  )
                })}
            </div>
          </div>
          <div className={styles.guides}>
            <div className={styles['footer-Guids-content']}>
              <div className={styles['footer-content-headline']}>{t['footer.guides']}</div>
              <div className={styles.guidesList}>
                {[
                  { title: t['footer.guide.why.echotik'], href: getLocalePath(''), wrapLink: false },
                  { title: t['footer.guide.pricing'], href: '/pricing/annually' },
                  {
                    title: t['my_report'],
                    href: getLocalePath('/reports'),
                    wrapLink: false
                  },
                  {
                    title: t['footer.guide.e-commerce.analysis'],
                    href: getLocalePath('/features/e-commerce'),
                    wrapLink: false
                  },
                  { title: t['menu.live.monitor'], href: getLocalePath('/features/live-monitor'), wrapLink: false },
                  {
                    title: t['footer.guide.extension'],
                    href: getLocalePath('/features/extension'),
                    wrapLink: false
                  },
                  {
                    title: t['footer.guides.tools'],
                    href: '/tool/ai/home'
                  },
                  {
                    title: t['footer.guides.changeLog'],
                    href:
                      lang === Language.zhCN
                        ? 'https://echosell.feishu.cn/wiki/Yj1gwFXfIi2M2xkV1tscLH2Znff'
                        : 'https://help.echotik.live/en/articles/6870452-echotik-upgrade-log',
                    wrapLink: false,
                    blank: true
                  },
                  {
                    title: t['menu.help.center'],
                    // href: lang === Language.zhCN ? 'https://help.echotik.live/zh-CN/' : 'https://help.echotik.live/en/',
                    href: 'https://help.echotik.live/en/',
                    wrapLink: false,
                    blank: true
                  },
                  {
                    title: t['footer.guide.promotion.alliance'],
                    href: getLocalePath('/affiliate-program'),
                    wrapLink: false
                  },
                  { title: t['footer.guides.blog'], href: '/blog', wrapLink: false, blank: true },
                  {
                    title: 'EchoTik社媒',
                    href: getLocalePath('/social-media'),
                    wrapLink: false,
                    hide: lang !== 'zh-CN'
                  },
                  {
                    title: '关于我们',
                    href: getLocalePath('/aboutus'),
                    wrapLink: false,
                    hide: lang !== 'zh-CN'
                  }
                ]
                  .filter((i) => !i.hide)
                  .map(({ title, href, wrapLink = true, blank, isCustom }, index) => {
                    if (isCustom) {
                      return <>{title}</>
                    }
                    if (wrapLink) {
                      return (
                        <Link href={href} key={index}>
                          <a className={styles.guidesItem}>{title}</a>
                        </Link>
                      )
                    }

                    return (
                      <a
                        key={index}
                        href={href}
                        className={styles.guidesItem}
                        target={blank ? '_blank' : '_self'}
                        rel="noreferrer"
                      >
                        {title}
                      </a>
                    )
                  })}
              </div>
            </div>
            <div style={{ marginTop: 20 }}>
              <a href="https://www.producthunt.com/products/echotik" target="_blank" rel="noreferrer">
                <Image
                  src="https://static.echotik.live/web/product_review.svg"
                  alt="EchoTik - EchoTik&#0046;live&#0032;is&#0032;a&#0032;TikTok&#0032;data&#0032;tool&#0046;&#0032;&#0032; | Product Hunt"
                  width={250}
                  height={54}
                />
              </a>
            </div>
          </div>
          <div className={styles.contactUs}>
            <div className={styles['footer-content-header']}>
              <div className={styles['footer-content-headline-left']}>{t['footer.contactUs']}</div>
              <div className={styles['footer-content-more']}>
                <a href={`/${lang === 'zh-CN' ? 'zh' : 'en'}/social-media`} target="_blank" rel="noreferrer">
                  {t['message.seeMore']}
                </a>
              </div>
            </div>
            <div className={styles.contactChannelList}>
              <div className={styles.contactChannelItem}>
                <Image width={36} height={36} src={Mailbox} alt="mail" />
                <a
                  className={styles.contactChannelItemName}
                  href="mailto:support@echosell.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Mailbox
                </a>
              </div>
              <div className={styles.contactChannelItem}>
                <Image width={36} height={36} src={FaceBook} alt="facebook" />
                <a
                  className={styles.contactChannelItemName}
                  href="https://www.facebook.com/echotik"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div className={styles.contactChannelItem}>
                <Image width={36} height={36} src={iconWhatsApp} alt="whatsapp" />
                <a
                  className={styles.contactChannelItemName}
                  href="https://chat.whatsapp.com/FmfhPcEqKJq40JeCrPlOhx"
                  target="_blank"
                  rel="noreferrer"
                >
                  WhatsApp
                </a>
              </div>
              <div className={styles.contactChannelItem}>
                <Image width={36} height={36} src={Twitter} alt="twitter" />
                <a
                  className={styles.contactChannelItemName}
                  href="https://twitter.com/EchosellM"
                  target="_blank"
                  rel="noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div className={styles.contactChannelItem}>
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <FaDiscord style={{ width: 20, height: 20, color: '#000' }} />
                </div>
                <a
                  className={styles.contactChannelItemName}
                  href="https://discord.gg/j5R55frXj4"
                  target="_blank"
                  rel="noreferrer"
                >
                  Discord
                </a>
              </div>
              <div className={styles.contactChannelItem}>
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <FaLinkedin style={{ width: 20, height: 20, color: '#000' }} />
                </div>
                <a
                  className={styles.contactChannelItemName}
                  href="https://www.linkedin.com/company/103295803/admin/feed/posts/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Linkedin
                </a>
              </div>
            </div>

            <div className={styles.qrCodeList}>
              {isNotChinese ? (
                <div className={styles.qrCodeItem}>
                  <Image
                    alt="image"
                    width={104}
                    height={104}
                    src={`https://static.echotik.live/qr_code/whatsapp_seller.png?t=${CACHE_TIMESTAMP}`}
                  />
                  <span>WhatsApp</span>
                </div>
              ) : (
                <div className={styles.qrCodeItem}>
                  <Image width={104} height={104} alt="image" src={Subscribe} />
                  <span>{t['footer.follow.official.account']}</span>
                </div>
              )}
              <div className={styles.qrCodeItem}>
                <Image width={104} height={104} alt="image" src={getCustomerServiceQrcodeUrl()} />
                <span>{t['footer.join.group']}</span>
              </div>
              <div className={styles.qrCodeItem}>
                <Image width={104} height={104} alt="image" src={getCustomerServiceQrcodeUrl()} />
                <span>{t['footer.contact.echoTik']}</span>
              </div>
            </div>
            {lang === Language.zhCN && (
              <div className={styles.moreGroup}>
                <div className={styles.moreGroupTitle}>TikTok专属分类交流群</div>
                <div className={styles.moreGroupDesc}>（美国/印尼/马来/越南…)</div>
                <div
                  className={styles.moreGroupBtn}
                  onClick={() => {
                    window.open(`https://help.echotik.live/zh-CN/articles/8119124`)
                  }}
                >
                  加入群聊
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={styles['footer-bottom']}>
          <div className={styles['footer-line']}></div>
          <div className={styles['footer-text']}>
            <span>{`Copyright ©${new Date().getFullYear()}`}</span>
            <a href="http://beian.miit.gov.cn" target="_blank" rel="noreferrer" style={{ marginLeft: '20px' }}>
              京ICP备2024093724号-1
            </a>
            <a href="http://beian.miit.gov.cn" target="_blank" rel="noreferrer" style={{ marginLeft: '20px' }}>
              京ICP备2023013450号-3
            </a>
            <a href="https://echotik.live/privacy-policy.html" target="_blank" rel="noreferrer">
              <span className={cs(styles['privacy-policy'], styles['footer-text'])}>{t['footer.policy']}</span>
            </a>
            {links.map((link, index) => {
              return (
                <Link href={link.href} key={link.href || index}>
                  <a style={{ marginLeft: '20px' }} target="_blank">
                    {link.name}
                  </a>
                </Link>
              )
            })}
            {/* <a href="https://app.echotik.live/terms.html" target="_blank" rel="noreferrer">
              <span className={styles['privacy-policy']}>{t['footer.service']}</span>
            </a> */}
            {/* <span style={{ paddingLeft: 25 }}>鄂ICP备2020017105号-2</span> */}
          </div>
        </div>
      </div>
      <UpdateLogComp visible={visible} setVisible={setVisible} updateLogs={updateLogs} />
    </Layout.Footer>
  )
}

export default Footer
